import { Injectable } from '@angular/core'

import { ExtendedCustomSensor } from '@ti/contracts'

import { BaseCustomSensorsProvider } from '../contracts'

@Injectable({ providedIn: 'root' })
export class CustomSensorsProvider extends BaseCustomSensorsProvider<ExtendedCustomSensor> {
  protected async getCustomSensors(): Promise<ExtendedCustomSensor[]> {
    return this.api.fleet.vehicle.listOfAvailableCustomSensors()
  }
}
